import React, { useState, useEffect, useContext } from 'react';

import './CartButton.css';

const cartIcon = 'https://cdn.obsess-vr.com/ferragamo/Bag.svg';

// TODO: PASS IN CART PAGE URL, CART TEXT STYLE, AND CART TEXT AS PROPS
const CartButton = ({ onClick, itemCount }) => {
    return (
        <div className='cart-button-container flex-center hoverable' onClick={onClick}>
            <div className='cart-icon-container flex-center'>
                <img className='cart-icon' src={cartIcon} />
                {(itemCount > 0) && <span className='item-count'>{itemCount}</span>}
            </div>
            {/* <span className='cart-button-text'>Cart</span> */}
        </div>
    )
}

export default CartButton;